module.exports = __webpack_public_path__ + "img/modal-delete.d6cf9282.svg";